import { ValidationError, string } from 'yup'

const resultLabelValidationSchema = string()
  .max(255, 'Labels cannot exceed 255 characters')
  .min(1, 'Labels cannot be empty')
  .test('no-space-in-label', 'Labels cannot contain spaces', value => !value?.includes(' '))

export const validateResultLabel = (value: string): { isValid: boolean; message?: string } => {
  try {
    resultLabelValidationSchema.validateSync(value)
  } catch (error) {
    return {
      isValid: false,
      message: error instanceof ValidationError ? error.message : 'Label validation failed'
    }
  }

  return { isValid: true }
}
